export default "__VITE_ASSET__9274cc32__"